import { Component } from '@angular/core';
import { AuthService, LoginCredential } from '../auth.service';
import { MatDialogRef } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'member-login',
  templateUrl: './member-login.component.html',
  styleUrls: ['./member-login.component.css']
})
export class MemberLoginComponent {

  toggle: boolean = false;

  email: string = '';
  password: string = '';

  constructor(private authService: AuthService, private dialogRef: MatDialogRef<MemberLoginComponent>){
  }

    cancel(){
      this.dialogRef.close();
    }
  
    openLoginDialog(){
      this.dialogRef.close(null);
      setTimeout(() =>{
        this.authService.openLoginDialog();
      }, 1000);
    }
  
    toggleView(){
      if(this.toggle){
        this.toggle = false;
      }else{
        this.toggle = true;
      }
    }
  
    async login(form: NgForm){
      if(form.invalid){
        this.authService.openSnackBar('Checkyour inputs', '');
        return;
      }
    
      let credential: LoginCredential ={
        email: form.value.email,
        password: form.value.password
      }
  
      try{
        let authResponse = await this.authService.memberLogin(credential);
      
        if(authResponse){
  
          //this.authService.storeAuthToken(authResponse);
          this.authService.updateAuthState(authResponse);
          this.password = '';
          this.email = '';
          this.authService.openSnackBar('Login succesful','');
          this.dialogRef.close(authResponse);
          form.reset();
  
          return 
        }
    
        this.authService.openSnackBar('There was an error login in', 'please try again');
  
      }catch(err){
        this.authService.openSnackBar('There was an error login in', 'please try again');
      }
  }
}
